<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat>
        <v-toolbar-title>Suppliers List</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>

        <v-row>
          <v-col cols="12" sm="12" md="6">
               <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>

            <!-- start of table -->
            <v-data-table
              :items-per-page="pageItems"
              :headers="headers"
              :items="suppliers"
              :search="search"
              :mobile-breakpoint="zeroValue"
            >
              <template v-slot:item.balance="{ item }">
                <span v-if="item.balance">{{item.balance.Balance.toLocaleString()}}</span>
              </template>
              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="editIcon" text :to="`/statement/supplier/${item.id}`" icon>
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>

        <v-row>
          <!-- suppliers dialog -->
          <v-dialog v-model="suppliersDialog" max-width="650px">
            <v-card>
              <v-toolbar dense color="primary" dark>
                <v-toolbar-title>Import Suppliers</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="suppliersDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <v-col cols="6">
                      <v-file-input
                        name="productExcelFile"
                        v-model="excelFile"
                        label="Browse Excel Sheet"
                        outlined
                        dense
                      ></v-file-input>
                    </v-col>

                    <v-col cols="12">
                      <v-btn color="accent" @click="uploadExcel" :loading="loader">
                        <v-icon left>mdi-upload</v-icon>Upload
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of modal-->

          <snackbar ref="snackbar"></snackbar>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    loader: false,
    suppliersDialog: false,
    excelFile: null,
    zeroValue: 0,
    pageItems: 100,
    headers: [
      { text: "Code", value: "CardCode" },
      { text: "Supplier Name", value: "Name" },
      { text: "Balance", value: "Balance" },
      { text: "Action", value: "action" },
    ],
    suppliers: [],
  }),
  methods: {
    uploadExcel() {
      const data = new FormData();
      data.append("suppliersData", this.excelFile);
      // send request
      this.loader = true;
      const url = "/import-suppliers";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$refs.snackbar.show(
              "Suppliers imported successfully",
              "green"
            );
            self.loader = false;
            self.excelFile = null;
            self.suppliersDialog = false;
            self.getSuppliers();
          } else {
            self.loader = false;
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
      // end
    },
    getSuppliers() {
      const self = this;
      this.$store
        .dispatch("get", `/suppliers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.suppliers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getSuppliers();
  },
};
</script>